export type PinColor = 'black' | 'white'

export type MarkerItem = {
  objectID: string
  name: string
  status: string
  slug: string
  organization_slug?: string
  _geoloc: {
    lat: number
    lng: number
  }
}

export const statusColorMap: Record<string, PinColor> = {
  icf: 'black'
}

export function getMarkerColor(status: string | undefined): PinColor {
  return status ? (statusColorMap[status] ?? 'white') : 'white'
}

export function getMarkerIcon(status: string | undefined): string | undefined {
  return status === 'microchurch' ? 'fa-solid fa-house' : undefined
}
